import { constraintsSorting } from '@elab/core/utils/constants';

export const collectMetadataConstraints = (metadata, constraintsReferences = []) => {
    if (metadata && Array.isArray(metadata.steps)) {
        metadata.steps.forEach(step => {
            collectMetadataConstraints(step, constraintsReferences);
        });
    }

    if (metadata && Array.isArray(metadata.fields)) {
        metadata.fields.forEach(field => {
            if (field && field.type && field.type.toLowerCase() === constraintsSorting.nestedType) {
                collectMetadataConstraints(field, constraintsReferences);
            }

            if (field.constraints) {
                constraintsReferences.push(field.constraints || []);
            }
        });
    }

    return constraintsReferences;
};

export const sortConstraints = (a, b) => {
    if (a.type === b.type) {
        return 0;
    }

    if (a.type === constraintsSorting.firstType) {
        return -1;
    }

    if (b.type === constraintsSorting.firstType) {
        return 1;
    }

    return 0;
};

export default metadata => {
    const constraintsReferences = collectMetadataConstraints(metadata);

    // constraints are sorted by reference (array reference, not pass by value);
    constraintsReferences.forEach(constraints => {
        if (Array.isArray(constraints)) {
            constraints.sort(sortConstraints);
        }
    });

    return metadata;
};
